import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "../../component/Header";
import Pagination from "../../component/Pagination";
import IconDelete from "../../component/SvgIcons/IconDelete";
import IconPen from "../../component/SvgIcons/IconPen";
import IconPlus from "../../component/SvgIcons/IconPlus";
import IconSearch from "../../component/SvgIcons/IconSearch";
import api from "../../Services/api";
import "../Events/style.css";
import { Tooltip } from "react-tooltip";
import { formatCountryDate } from "../../Services/countryTime";
export default function ExeUploadsList() {
  const [downloads, setDownloads] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig] = useState({ key: null, direction: "asc" });
  const [itemsPerPage, setItemsPerPage] = useState(10);  
 
    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth >= 1920) {
          setItemsPerPage(20);
        } else {
          setItemsPerPage(10);
        }
      };
      handleResize(); // Set initial value
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);


  useEffect(() => {
    fetchDownloads();
  }, []);

  const fetchDownloads = async () => {
    try {
      const response = await api.post("/viewDownload"); // Correct API call
      setDownloads(response.data);
    } catch (error) {
      console.error(" Error fetching downloads:", error);
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const sortedDownloads = [...downloads].sort((a, b) => {
    if (!sortConfig.key) return 0;
    if (a[sortConfig.key] < b[sortConfig.key])
      return sortConfig.direction === "asc" ? -1 : 1;
    if (a[sortConfig.key] > b[sortConfig.key])
      return sortConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

    const filteredDownloads = sortedDownloads.filter((download) => {
    const name = download.name ? download.name.toLowerCase() : "";
    const description = (download.description || download.desc || "").toLowerCase();
    const exeFileName = (download.exeFile || download.exe_file || "").toLowerCase();
    const imageValue = Array.isArray(download.image)
      ? download.image.join(" ")
      : download.image || download.imageFile || download.image_file || download.imageFilename || "";
    const imageName = imageValue.toLowerCase();
    const version = (download.version || download.file_version || "").toLowerCase();
    const formattedDate = formatCountryDate(download.DateTime)
      .replace(/\//g, "-"); // ✅ Convert to DD-MM-YYYY

    return (
      name.includes(searchQuery.toLowerCase()) ||
      description.includes(searchQuery.toLowerCase()) ||
      exeFileName.includes(searchQuery.toLowerCase()) ||
      imageName.includes(searchQuery.toLowerCase()) ||
      version.includes(searchQuery.toLowerCase()) ||
      formattedDate.includes(searchQuery)
    );
  });

  const currentDownloads = filteredDownloads.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const totalPages = Math.ceil(filteredDownloads.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this download?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      // Send DELETE request with the ID in the URL
      await api.post(`/deleteDownLoad/${id}`);

      // Update UI after deletion
      setDownloads((prevDownloads) =>
        prevDownloads.filter((download) => download.id !== id)
      );

      await Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Download deleted successfully.",
      });
    } catch (error) {
      console.error("Error deleting download:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "An error occurred while deleting the download.",
      });
    }
  };

  return (
    <section className="eventpage">
      <Header pageTitle="EXE Files List" />
      <div className="pageLeftspace">
        <div className="d-flex justify-content-between align-items-center topsearchbar">
          <div className="d-flex align-items-center gap-2">
            <Link
              to="/add-exe-file-upload"
              className="btn btn-purpal addbutton"
            >
              <IconPlus /> Add New Exe
            </Link>
          </div>

          <div className="input-container">
            <input
              type="text"
              id="search"
              placeholder="Search Here.."
              value={searchQuery}
              onChange={handleSearchChange}
            />
            {/* <label htmlFor="password">Search here..</label> */}
            <span className="underline"></span>
            <div className="search-icon">
              <IconSearch />
            </div>
          </div>
        </div>

        <div className="tableheader d-flex flex-column gap-4">
          <div className="event-detailstable">
            <table className="table">
              <thead>
                <tr>
                  <th width="10px" align="center">
                    Sr. No.
                  </th>
                  <th width="50px">Date</th>
                  <th>Product Name</th>
                  <th>EXE File</th>
                  <th>Image</th>
                  <th>Version</th>
                  <th>Description</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {currentDownloads.length > 0 ? (
                  currentDownloads.map((download, index) => {
                    const version = download.version || download.file_version || "";
                    const imageFilename =
                      Array.isArray(download.image) && download.image.length > 0
                        ? download.image[0]
                        : download.image || download.imageFile || download.image_file || download.imageFilename || "";
                    const imageUrl = imageFilename
                      ? /^https?:\/\//i.test(imageFilename)
                        ? imageFilename
                        : `${process.env.REACT_APP_API_PRJ_URL}/uploads/exe/${imageFilename}`
                      : "";
                    return (
                      <tr key={download.id}>
                        <td align="center">{index + 1}</td>
                        <td>
                          {formatCountryDate(download.DateTime)
                            .replace(/\//g, "-")}
                        </td>
                        <td>{download.name}</td>
                        <td>{download.exeFile || ""}</td>
                        <td className="image-cell">
                          {imageUrl ? (
                            <img
                              src={imageUrl}
                              alt={download.name || "Image"}
                              className="image-thumbnail"
                            />
                          ) : (
                            ""
                          )}
                        </td>
                        <td>{version}</td>
                        <td>{download.description || download.desc || ""}</td>
                        <td>
                          <div className="action">
                            <Link
                              to={`/edit-download/${download.id}`}
                              className="editbtn"
                              data-tooltip-id={`edit-${download.id}`}
                              data-tooltip-content="Edit"
                            >
                              <IconPen />
                            </Link>
                            <Tooltip id={`edit-${download.id}`} place="top" />

                            <Link
                              to="#"
                              onClick={() => handleDelete(download.id)}
                              data-tooltip-id={`delete-${download.id}`}
                              data-tooltip-content="Delete"
                            >
                              <IconDelete />
                            </Link>
                            <Tooltip id={`delete-${download.id}`} place="top" />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      style={{ textAlign: "center", padding: "10px" }}
                    >
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={
              filteredDownloads.length > itemsPerPage ? totalPages : 0
            }
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </section>
  );
}
